<template>
  <div class="modal" v-if="value">
    <div class="modal-mask" @click.self="handleClose">
      <div class="modal-container">
        <!-- 弹窗头部 -->
        <div class="modal-header">
          <h3>{{ title }}</h3>
          <button class="modal-close" @click="handleClose">×</button>
        </div>

        <!-- 弹窗内容 -->
        <div class="modal-body">
          <slot>
            默认内容。
          </slot>
        </div>

        <!-- 弹窗底部按钮 -->
         <slot name="footer">
            <div class="modal-footer">
            <!-- <button @click="handleCancel">取消</button> -->
            <button id="confirm" @click="handleConfirm" type="primary">提交</button>
            </div>
         </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    }
  },
  watch: {
    value(val) {
        console.log("val", val)
    //   if (val) {
    //     document.body.style.overflow = 'hidden';
    //   } else {
    //     document.body.style.overflow = 'auto';
    //   }
    }
  },

  methods: {
    handleClose() {
      this.$emit('update:value', false);
      this.$emit('cancel');
    },
    handleCancel() {
      this.$emit('cancel');
      this.handleClose();
    },
    handleConfirm() {
      this.$emit('confirm');
      // this.handleClose();
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
}

.modal-mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  max-width: 674px;
  width: 100%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.modal-close {
  font-size: 34px;
  cursor: pointer;
  border: none;
  background: transparent;
}

.modal-body {
  font-size: 14px;
  color: #333;
  padding: 0 60px;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-footer {
  margin-top: 10px;
  margin-bottom: 28px;
  text-align: center;
}

.modal-footer button {
    width: 180px;
    height: 48px;
    background: #165DFF;
    border-radius: 2px 2px 2px 2px;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/modal.vue